import BaseIndexedDB from '../IndexedDB/IndexedDB';
import BaseSchemaUpgrade from '../IndexedDB/SchemaUpgrade';

export const IndexedDB = BaseIndexedDB;
export type SchemaUpgrade = BaseSchemaUpgrade;